import { render, staticRenderFns } from "./setStation.vue?vue&type=template&id=5a5aded2&scoped=true"
import script from "./setStation.vue?vue&type=script&lang=js"
export * from "./setStation.vue?vue&type=script&lang=js"
import style0 from "./setStation.vue?vue&type=style&index=0&id=5a5aded2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5aded2",
  null
  
)

export default component.exports